import React, { useEffect, useState, useRef } from 'react';
import {
  View,
  StyleSheet,
  Image,
  useWindowDimensions,
  TouchableOpacity,
  Platform,
  ScrollView,
  Pressable,
  Text 
} from 'react-native';
import { useForm, FormProvider } from 'react-hook-form';
import FieldBuilder from '../../../../components/shared/FieldBuilder/FieldBuilder';
import I18n from '../../../../components/shared/i18n/I18n.component';
import { TimeMode } from '../../../../components/shared/FieldBuilder/TimePicker/TimePicker.component';
import colors from '../../../../config/colors';
import OutlineButtonContainer from '../../../../components/shared/Buttons/OutlineButton.container';
import SolidButtonContainer from '../../../../components/shared/Buttons/SolidButton.container';
import moment, { duration } from 'moment';
import { getState } from '../../../../store/store';
import useDevicePlatform, {
  DeviceType,
} from '../../../../hooks/useDevicePlatform.hook';
import httpService from '../../../../services/http.service';
import { convertTimeToUtc } from '../../../../modals/AddRequestModal/AddRequestModal.utils';
import { cantReportModal, convertFromUtc, openAlertModal } from '../Clock.utils';
const timeIcon = require('../../../../../assets/icons/sandTime/time.png');
import { getTotalReportedByDate } from '../../../../modals/AddRequestModal/AddRequestModal.utils';
import { modalService } from '../../../../services/modal.service';
import AlertModal from '../../../../modals/AlertModal/AlertModal.component';
import { openStore } from '../../../../utils/globals.utils';
import { getLocationPermission } from '../../../../utils/permissions.utils';
import { useSelector } from 'react-redux';
import { getUserData } from '../../../../store/selectors/login.selectors';
import Loader from '../../Loader/Loader.component';
import ActionButtonContainer from '../../Buttons/ActionButton.container';
import { snackbarService } from '../../../../services/snackbar.service';
import { i18nService } from '../../../../services/i18n.service';
export interface formValues {
  date: string;
  exitTime: string;
  entryTime: string;
  projectId: string;
  eventId: string;
}
interface Props {
  submitBtnText: string;
  cancelBtnText: string;
  prevValues: PrevValues;
  projectsOptions: any[];
  eventsOptions: any[];
  shiftHours: number;
  handleSubmit: Function;
  onCancel: Function;
  onNext?: Function;
  checkIfCanEntry: Function;
  totalReported: number;
}
interface PrevValues {
  date: string;
  projectId: string;
  eventId: string;
}

const CompleteEntryComponent = ({
  prevValues,
  submitBtnText,
  cancelBtnText,
  projectsOptions,
  eventsOptions,
  shiftHours,
  handleSubmit,
  onCancel,
  onNext,
  checkIfCanEntry,
  totalReported,
}: Props) => {
  const hasEventOrProjectsFilter =
    projectsOptions?.length || eventsOptions?.length ? true : false;
  const userData = useSelector(getUserData);

  const screenWidth = useWindowDimensions().width - 50;
  const platform = useDevicePlatform();
  const isMobile = platform !== DeviceType.WEB;
  const isWebOrMobileweb = platform !== DeviceType.MOBILE;
  const [entryTimeError, setEntryTimeError] = useState(false);
  const [HoursError, setHoursError] = useState(
    <View style={{ height: 17 }} />,
  );
  const isPrevDayShift = useRef(false);
  const [date, setDate] = useState(prevValues.date);
  const [yesterdayTotalReported, setYesterdayTotalReported] = useState(0);
  const formMethods = useForm({
    defaultValues: {
      ...prevValues,
      date: moment().format('DD/MM/YY'),
      entryTime: '',
    },
    mode: 'onBlur',
  });
  const entryTime = formMethods.watch('entryTime');
  useEffect(() => {
    getTotalReportedByDate(
      moment().subtract(1, 'day').format('YYYY-MM-DD'),
      false,
      null,
    ).then(total => {
      setYesterdayTotalReported(total);
    });
  }, []);

  useEffect(() => {
    const forms = formMethods.getValues();
    if (!forms.entryTime) return;
    const entry = moment(forms.entryTime, 'HH:mm');
    const exit = moment(
      convertFromUtc(
        getState().dateTime.currentDateTime,
        true,
        false,
        'YYYY-MM-DDTHH:mm',
      ),
      'HH:mm',
    );

    const currentAndEntryDiff = exit.diff(entry, 'minutes') / 60;
    const diffForPrevDate = entry.diff(exit, 'minutes') / 60;
    const remainShiftHours = shiftHours - totalReported; //parameter x - reportedHours
    const yesterdayRemainShiftHours = shiftHours - yesterdayTotalReported;

    if (currentAndEntryDiff > 0) {
      //if entry < exit
      if (isPrevDayShift.current) {
        const currentDate = moment(prevValues.date, 'DD/MM/YY').format(
          'DD/MM/YY',
        );
        formMethods.setValue('date', currentDate);
        setDate(currentDate);
        isPrevDayShift.current = false;
      }
      if (currentAndEntryDiff > remainShiftHours) {
        setEntryTimeError(true);
        setHoursError(hoursErrorHandler('shiftTimeOverflow'));
      } else {
        setEntryTimeError(false);
        setHoursError(hoursErrorHandler(''));
      }
      return;
    }
    if (diffForPrevDate > 0) {
      if (!isPrevDayShift.current) {
        //setting the date to yesterday
        const prevDate = moment(forms.date, 'DD/MM/YY')
          .subtract(1, 'day')
          .format('DD/MM/YY');
        formMethods.setValue('date', prevDate);
        setDate(prevDate);
        isPrevDayShift.current = true;
        setEntryTimeError(false);
        setHoursError(hoursErrorHandler(null));
      }
      if (24 - diffForPrevDate > yesterdayRemainShiftHours) {
        //if entry is grater then exit => yesterday report shift max hour check
        // check yesterday remain hours
        setEntryTimeError(true);
        setHoursError(hoursErrorHandler('shiftTimeOverflow'));
      } else {
        setEntryTimeError(false);
        setHoursError(hoursErrorHandler(null));
      }
      return;
    } else {
      if (isPrevDayShift.current) {
        const currentDate = moment(prevValues.date, 'DD/MM/YY').format(
          'DD/MM/YY',
        );
        formMethods.setValue('date', currentDate);
        setDate(currentDate);
        isPrevDayShift.current = false;
      }
      setEntryTimeError(false);
      setHoursError(hoursErrorHandler(''));
    }
  }, [entryTime]);

  const hoursErrorHandler = (errorType: string) => {
    switch (errorType) {
      case 'entryOverflowExit':
        return (
          <I18n size={14} color={'red'} weight='bold'>
            general.overTimeError2
          </I18n>
        );

      case 'shiftTimeOverflow':
        return (
          <View style={{ flexDirection: 'row-reverse' }}>
            <I18n size={14} color={'red'} weight='bold'>
              general.maxShiftTimeError
            </I18n>
            <I18n size={14} color={'red'} weight='bold'>
              {` ${shiftHours} `}
            </I18n>
            <I18n size={14} color={'red'} weight='bold'>
              general.maxShiftTimeError2
            </I18n>
          </View>
        );
      case 'OVERLLAPING':
        return (
          <I18n size={14} color={'red'} weight='bold'>
            general.validation.overlappingReport
          </I18n>
        );
      default:
        return <View style={{ height: 17 }} />;
    }
  };
  const Submit = async (forms: formValues) => {
    try {
      if (isWebOrMobileweb && !checkIfCanEntry({ id: forms.projectId })) {
        cantReportModal(isMobile, userData?.location.find(pr => pr.projectId === forms.projectId))
      } else {
        let lat = null;
        let lon = null;
        if (
          platform === DeviceType.MOBILE &&
          !checkIfCanEntry({ id: forms.projectId })
        ) {
          const location = await getLocationPermission();
          lat = location?.coords?.latitude || null;
          lon = location?.coords?.longitude || null;
          if (!location) {
            onCancel(onNext);
            return;
          }
        }

        const data = {
          date: moment(forms.date, 'DD/MM/YY').format('YYYY-MM-DD'),
          enterTime: convertTimeToUtc(
            forms.entryTime,
            forms.date,
            'DD/MM/YY',
            true,
          ),
          projectId: forms.projectId || null,
          exitTime: moment().utc().format('YYYY-MM-DDTHH:mm'),
          //later just spread the {...forms} so that the projects and event will be at the body to..
          mobile: !isWebOrMobileweb,
          lat,
          lon,
        };

        if (Platform.OS !== 'web') {
          const crashlytics = (
            await import('@react-native-firebase/crashlytics')
          ).default;
          crashlytics().recordError(
            new Error(
              `exitClockWorkLog from complete entry data: ${JSON.stringify(data)} `,
            ),
          );
        }

        const res = await httpService.api<any>({
          type: 'exitClockWorkLog',
          data,
        });
        handleSubmit(onNext, forms.date);
      }
    } catch (error) {
      if (error?.data?.error) {
        switch (error.data.error) {
          case 'OVERLAPPING_ERROR':
            snackbarService.show({
              message: i18nService.translate('general.validation.overlappingReport'),
              success: false,
            });
            onCancel(onNext);
            break;
          case 'PARTIAL_ERROR':
            snackbarService.show({
              message: i18nService.translate('general.validation.overlappingReport'),
              success: false,
            });
            onCancel(onNext);
            break;
          case 'LOCATION_PROJECT_ERROR':
            platform === DeviceType.MOBILE ? openAlertModal(
              'workLogError.project.phone',
              'attention',
              'general.close',
            ) : cantReportModal(isMobile, userData?.location.find(pr => pr.projectId === forms.projectId))
            onCancel(onNext);
            break;
          case 'LOCATION_ERROR':
            platform === DeviceType.MOBILE ? openAlertModal(
              'workLogError.location.phone',
              'attention',
              'general.close',
            ) : cantReportModal(isMobile, userData?.location.find(pr => pr.projectId === forms.projectId))
            onCancel(onNext);
            break;
          default:
            onCancel(onNext);
            break;
        }
      } else {
        onCancel(onNext);
      }
    }
  };
  const actionButtons = (
    <View style={[styles.actionButtons, { paddingTop: 24 }]}>
      <ActionButtonContainer
        disabled={
          !formMethods.getValues().entryTime || entryTimeError
        }
        overrideStyle={{
          width: isMobile? screenWidth * 1 : 100,
          backgroundColor: entryTimeError
            ? '#cacaca'
            : colors.titlePrimary,
          borderRadius: 8,
          ...Platform.select({ ios: { flexDirection: 'row', marginBottom: 12 } }),
        }}
        hoverStyle={{backgroundColor: colors.primaryDark }}
        onPress={() => Submit(formMethods.getValues())}
      >
        <I18n
          size={15}
          weight='400'
          color='white'
        >
          {submitBtnText}
        </I18n>
      </ActionButtonContainer>
      <ActionButtonContainer
        overrideStyle={[styles.buttonCancel, { width: isMobile? screenWidth * 1 : 100 }]}
        onPress={() => onCancel(onNext)}
      >
        <I18n
          size={15}
          weight='400'
          color='primary'
        >
          {cancelBtnText}
        </I18n>
      </ActionButtonContainer>
    </View>
  );

  return (
    <FormProvider {...formMethods}>
      <View style={{ flex: 1 }}>
        <ScrollView
          showsVerticalScrollIndicator
          style={{
            shadowColor: 'rgba(0, 0, 0, 0)',
            shadowOpacity: 0.1,
            shadowOffset: { width: 0, height: 2 },
            backgroundColor: colors.white,
            borderRadius: 20,
            width: isMobile ? screenWidth : 408,
             ...(isMobile ? { flex: 1 } : { height: 'auto' }),
          }}
          contentContainerStyle={{
            ...Platform.select({
              web: {  paddingVertical: 39,
                      paddingHorizontal: 20, },
              //ios: { flexGrow: 1 },
            }),
            alignItems: 'center',
            flexDirection: 'column',

          }}
        >
          <View style={{ width: '100%', display: 'flex', direction: 'rtl'}}>
            <View style={{ width: '100%', display: 'flex', gap: 24}}>
              { !isMobile && (
                <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                  <View style={{ display: 'flex', flexDirection: 'row', ...Platform.select({ ios: { gap: 12 }, web: {  gap: 12, alignItems: 'center'  } }) }} >
                    <I18n font='medium' size={17} color='primaryDarkBlue' style={{ letterSpacing: 0.15 }}>
                      general.reportDate
                    </I18n>
                    <I18n weight='400' size={17} color='primaryDarkBlue' style={{ letterSpacing: 0.4 }}>
                      {date}
                    </I18n>
                  </View>

                  <Pressable onPress={onNext} style={styles.closeButton}>
                    <Text style={styles.closeButtonText}>×</Text>
                  </Pressable>
                </View>
                )}

              <View style={{ width: '100%', gap: 8, direction:'ltr'}}>
                <View style={{ flexDirection: 'row-reverse', gap: 4, alignItems: 'center', ...Platform.select({ ios: { paddingHorizontal: 8, marginBottom: 12 } }) }}>
                  <I18n
                    style={{ alignSelf: 'stretch', textAlign: 'right', letterSpacing: 0.4 }}
                    weight='400'
                    size={12}
                    color='primaryDarkBlue'
                  >
                    general.CompleteEntry
                  </I18n>
                  <I18n weight='400' size={12} color='red' style={{ marginRight: 4 }}>
                    {' *'}
                  </I18n>
                </View>


                <FieldBuilder
                  type={'timePicker'}
                  name={'entryTime'}
                  defaultTime={null}
                  style={{width: '100%'}}
                  styles={{
                    wrapper: { direction: 'ltr' },
                  }}
                  hideLabel={true}
                  editable={true}
                  mode={TimeMode.Entry}
                  error={entryTimeError}
                  inputContainerStyle={{
                    height: 40,
                    ...Platform.select({ ios: { flex: 1 }, web: { paddingHorizontal: 16, paddingVertical: 10, } }),
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 10,
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: '#D1D4DC',
                    backgroundColor: '#FFF',

                  }}
                  inputStyle={{
                    flex: 1,
                    fontFamily: 'RubikRegular',
                    fontSize: 14,
                    fontWeight: '400',
                    fontStyle: 'normal',
                    color: entryTimeError ? 'red' : colors.greyText,
                    ...Platform.select({ web: { width: '100%' } }),
                  }}
                  buttonStyle={{
                    marginVertical: 0,
                    marginHorizontal: 8,
                    height: 20,
                  }}
                />


                <View style={{ alignSelf: 'flex-end' }}>
                  {HoursError}
                </View>

              </View>

            </View>



          </View>
          {/* Web: modal is auto-height with no bounded parent, so buttons must live inside the
              scroll content to flow naturally beneath the form */}
          {!isMobile && actionButtons}
        </ScrollView>
        {/* Mobile: bottom sheet has a fixed height (90% of screen), so buttons live outside
            the ScrollView as a pinned sibling that stays anchored at the bottom */}
        {isMobile && actionButtons}
      </View>
      <Loader />
    </FormProvider>
  );
};
const styles = StyleSheet.create({
  actionButtons: {
    width: '100%',
    ...Platform.select({
      web: { flexDirection: 'row'  },
      ios: { flexDirection: 'column', justifyContent: 'flex-end', },
    }),
    gap: 16,
    ...Platform.select({ ios: {marginBottom: 16} }),
    alignItems: 'center',
  },
  buttonOk: {
    minWidth: 92,
    height: 40,
    justifyContent: 'center',
    backgroundColor: colors.lightPrimary,
    paddingHorizontal: 15,
    padding: 10,
  },
  buttonCancel: {
    minWidth: 100,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 11,
    borderWidth: 1,
    borderColor: colors.titlePrimary,
  },
  closeButton: {
		padding: 4,
		marginLeft: 8,
	},
  closeButtonText: {
		fontSize: 28,
		color: colors.darkGrey,
		lineHeight: 28,
	},
});
export default CompleteEntryComponent;
